import { _, $, Backbone, Foundation } from "../../../vendor";
import { Backform, Notification } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import Calendar from "../../models/Calendar";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

export default InboomaBaseView.extend({
  template: _.noop,
  el: "#inb-modal-calendars",

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    this.getUI("errorMessageField").addClass("hide");

    if (this.model.get("id") == "") {
      this.$el.find(".calendar-help").removeClass("hide");
    } else {
      this.$el.find(".calendar-help").addClass("hide");
      this.$el
        .find(".inb-page-title")
        .html(this.t("edit_${a}", { a: this.t("calendar") }, "capital"));
    }

    const that = this,
      fields = [
        {
          name: "title",
          label: this.t("name", null, "capital"),
          required: true,
          control: "input",
          size: {
            large: "6",
          },
        },
        {
          name: "description",
          label: this.t("description", null, "capital"),
          required: true,
          control: "input",
          size: {
            large: "6",
          },
        },
        {
          label: this.t("save"),
          control: "button",
          extraClasses: ["expanded button-submit"],
        },
        {
          name: "remove-calendar",
          control: "uneditable-input",
          visible: (model) => model.get("id") != "",
          extraTopClasses: ["fake-link text-right"],
          label: that.t("remove", null, "capital"),
          size: {
            small: "12",
          },
        },
      ],
      calendarsModal = new Foundation.Reveal(this.$el),
      form = new Backform.Form({
        el: that.$el.find(".inb-calendars-form__content"),
        model: that.model,
        fields: fields,

        events: {
          submit: function () {
            return false;
          },

          "click .remove-calendar": (ev) => {
            ev.preventDefault();

            if (confirm(this.t("really_remove"))) {
              that.model.destroy({
                success: (model, repsonse) => {
                  calendarsModal.close();

                  new Notification({
                    message: that.t("removed_${a}", { a: that.t("calendar") }, "capital"),
                    duration: 5000,
                    closeable: true,
                    icon: "fi fi-trash",
                  });
                },
                error: () => {
                  new Notification({
                    message: that.t("request_error"),
                    duration: 5000,
                    type: "warning",
                    closeable: true,
                    icon: "fi fi-x",
                  });
                },
              });
            }
          },

          "click .button-submit": function (ev) {
            ev.preventDefault();
            that.$el.find("form .is-invalid-input").removeClass("is-invalid-input");

            $(that.$el.find("form")).foundation("validateForm");

            if (
              typeof that.model != "undefined" &&
              that.model.isValid() &&
              !that.$el.find("form .is-invalid-input").length
            ) {
              that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);

              console.log("collection & this.model", that.collection, that.model);

              that.model.save(null, {
                success: (model, response) => {
                  model = new Calendar(model.toJSON());

                  that.collection.set(model, { add: true, merge: true, remove: false });
                  calendarsModal.close();

                  if (that.collection.models.length == 1) {
                    that.collection.trigger("forceRender");
                  }

                  new Notification({
                    message: that.t("saved_${a}", { a: that.t("calendar") }, "capital"),
                    duration: 5000,
                    type: "success",
                    closeable: true,
                    icon: "fi fi-marker",
                  });

                  //window.location.reload();
                },
                error: (model, response, options) => {
                  that
                    .getUI("errorMessageField")
                    .removeClass("hide")
                    .html(that.t("request_error"))
                    .fadeIn("fast");
                },
              });
            } else {
              if (typeof that.model != "undefined") {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("form_validation_error"))
                  .fadeIn("fast");
              }
            }
          },
        },
      }).render();

    new Foundation.Abide(that.$el.find("form"), { liveValidate: true });

    console.log("rendered", calendarsModal);

    calendarsModal.open();

    $(document).on("closed.zf.reveal", () => {
      // @TODO Same bug as his time in offCanvasBehavior
      Backbone.history.navigate("appointments", { trigger: true });
      that.remove();
      that.destroy();
      that.unbind();
      delete that.model;
      $(document).off("closed.zf.reveal");
    });
  },
});
